import { ref as rtdbRef, get as rtdbGet, runTransaction } from 'firebase/database';
import { rtdb } from './firebase';
import { DEFAULT_WHATS_NEW_CONFIG, WHATS_NEW_PATH, resolveWhatsNewTitle } from './whatsNewConstants';

export * from './whatsNewConstants';

export async function getWhatsNewTitle(): Promise<string> {
  const snap = await rtdbGet(rtdbRef(rtdb, `${WHATS_NEW_PATH}/title`));
  return resolveWhatsNewTitle(snap.exists() ? snap.val() : undefined);
}

/**
 * Write the §3.1 defaults if, and only if, the node does not exist yet.
 *
 * A transaction so a second admin (or a second click) can never overwrite a
 * node somebody has already configured: an existing value aborts the write and
 * is reported back. Resolves `true` when this call created the node.
 */
export async function seedWhatsNewConfigIfAbsent(): Promise<boolean> {
  const result = await runTransaction(rtdbRef(rtdb, WHATS_NEW_PATH), (current) => {
    if (current !== null) return undefined; // abort: already configured
    return { ...DEFAULT_WHATS_NEW_CONFIG };
  });
  return result.committed;
}
